import React from "react";
import CountUp from "react-countup";
import { FaProjectDiagram, FaBriefcase, FaLinkedin, FaClock } from "react-icons/fa";

export default function Stats() {
  const statsData = [
    { icon: <FaProjectDiagram size={36} />, number: 12, label: "Projects Completed" },
    { icon: <FaBriefcase size={36} />, number: 3, label: "Internships" },
    { icon: <FaLinkedin size={36} />, number: 500, label: "LinkedIn Connections" },
    { icon: <FaClock size={36} />, number: 100, label: "Hours of Freelance Work" },
  ];

  return (
    <section id="stats" className="py-5" style={{ background: "#1a1a2e", color: "#fff" }}>
      <div className="container text-center">
        <h2 className="fw-bold mb-4">My Achievements</h2>
        <div
          className="mx-auto mb-5"
          style={{
            width: "80px",
            height: "3px",
            background: "linear-gradient(135deg, #ff4e50, #f9d423)",
            borderRadius: "2px",
          }}
        ></div>

        <div className="row text-center">
          {statsData.map((stat, idx) => (
            <div key={idx} className="col-6 col-md-3 mb-4">
              <div className="d-flex flex-column align-items-center">
                <div className="mb-2 text-warning">{stat.icon}</div>
                <h3 className="display-5 fw-bold">
                  {/* slow animation: 4 seconds */}
                  <CountUp end={stat.number} duration={4} />+
                </h3>
                <p className="text-light">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
